module.exports = __webpack_public_path__ + "static/media/MXN.3baf1d11.svg";